import { Routes, RouterModule } from '@angular/router';
import { PagesURLs } from './pages.url';
import { Outlets } from '../layouts/layouts.outlet';
import { ComponentOutlets } from '../components/components.outlet';
import {
  IdentificationLayoutComponent,
  MessageLayoutComponent,
  CardLayoutComponent
} from '../layouts';
import {
  IdentificationComponent,
  IdentificationHelpComponent,
  IdentificationSuccessComponent,
  ChangePasswordComponent,
  ChangePasswordFormComponent,
  ChangePasswordSuccessComponent
} from '.';


const routes: Routes = [
  {
    path: PagesURLs.IDENTIFICATION, component: IdentificationLayoutComponent, children: [
      { path: PagesURLs._BLANK, component: IdentificationComponent, outlet: Outlets.IDENTIFICATION },
      { path: PagesURLs._BLANK, component: IdentificationHelpComponent, outlet: Outlets.HELP }
    ],
  },
  {
    path: PagesURLs.IDENTIFICATION_SUCCESS, component: MessageLayoutComponent, children: [
      { path: PagesURLs._BLANK, component: IdentificationSuccessComponent, outlet: Outlets.MESSAGE }
      /* { path: PagesURLs._BLANK, component: IdentificationSuccessHelpComponent, outlet: Outlets.HELP } */
    ]
  },
  {
    path: PagesURLs.CHANGE_PASSWORD, component: CardLayoutComponent, children: [{
      path: PagesURLs._BLANK, component: ChangePasswordComponent, outlet: Outlets.CARD, children: [
        { path: PagesURLs._BLANK, component: ChangePasswordFormComponent, outlet: ComponentOutlets.CARD_BODY }
      ]
    }]
  },
  {
    path: PagesURLs.CHANGE_PASSWORD_SUCCESS, component: MessageLayoutComponent, children: [
      { path: PagesURLs._BLANK, component: ChangePasswordSuccessComponent, outlet: Outlets.MESSAGE }
      /* { path: PagesURLs._BLANK, component: ChangePasswordHelpComponent, outlet: Outlets.HELP } */
    ]
  },
];

export const PagesRoutes = RouterModule.forChild(routes);
